import React, { useEffect } from "react";

import { Col, Row } from "react-bootstrap";
import { fetchStreamChildren, sortStream } from "../../../redux/actions/streams";
import { useDispatch } from "react-redux";
import { persistStreamSortPreference } from "../../../utils/stream.helper";
import { fetchGroupChildren, sortGroup } from "src/redux/actions/groups";
import styles from "./streamHeader.module.scss";
import cx from "classnames";
import _ from "lodash";
import userRoleService from "src/utils/userRoles.service";

interface StreamHeaderProps {
  id: string;
  entityType: string;
  updateSortOrder: (sortBy: string, orderBy: string) => void;
  sortPreference: { sortBy: string; orderBy: string };
}

const StreamHeader: React.FC<StreamHeaderProps> = ({id, entityType, updateSortOrder, sortPreference}) => {

  const dispatch = useDispatch();

  useEffect(() => {
  }, []);

  const renderSort = (orderA: string, orderB: string, sort: string) => {

    return (
      <span className={cx(styles.sort, {
        [styles.hideSort]: sortPreference.sortBy !== sort,
      })}>
      <i className={cx("fa-solid fa-angle-up", {[styles.active]: sortPreference.orderBy === orderA && sortPreference.sortBy === sort})} onClick={() => handleSort(sort)}></i>
      <i className={cx("fa-solid fa-angle-down", {[styles.active]: sortPreference.orderBy === orderB && sortPreference.sortBy === sort})} onClick={() => handleSort(sort)}></i>
      </span>
    )
  }

  const handleSort = (sort: string) => {
    const order = sortPreference.orderBy === "ASC" ? "DESC" : "ASC";

    updateSortOrder(sort, order);
    persistStreamSortPreference(sort, order);

    if (sort === "name" || sort === "modified_date") {
      if (entityType === "group") {
        dispatch(fetchGroupChildren({ id: id || "", page: 0, limit: 25, sort: { type: sort, order } }));
      } else {
        dispatch(fetchStreamChildren({ id: id || "", page: 0, limit: 25, sort: { type: sort, order } }));
      }
    } else {
      if (entityType === "group") {
        dispatch(sortGroup({ sort: { type: sort, order }, id: id || "" }));
      } else {
        dispatch(sortStream({ sort: { type: sort, order }, id: id || "" }));
      }
    }
  };
  
  const analytics = ["views", "shares", "downloads", "timeSpent"].filter(
    (item) => item !== "shares" || userRoleService.canShare()
  );

  return (
      <Row className={styles.container}>
      <Col md={3} className={styles.name}>
      <span onClick={() => handleSort("name")}>Name</span>
      {renderSort("ASC", "DESC", "name")}
      </Col>

      <Col md={2} className={styles.lastUpdated}>
        <span onClick={() => handleSort("modified_date")}>Last Update</span>
        {renderSort("ASC", "DESC", "modified_date")}
      </Col>

      <Col md={2} className={styles.createdBy}>
        <span onClick={() => handleSort("created")}>Created by</span>
        {renderSort("ASC", "DESC", "created")}
      </Col>
      <Col md={5}>
      <Row className={styles.analytics}>
        {analytics.map((item, index) => {
          return (
            <Col md={3} key={index} className={styles[item]}>
            <span onClick={() => handleSort(item)}>{_.capitalize(item)}</span>
            {renderSort("ASC", "DESC", item)}
            </Col>
          );
        })}
    </Row>
    </Col>
    </Row>

  );
};

export default StreamHeader;
